module.exports = {
  pleaseWait: 'Please wait',
  FAQ: 'FAQ',
  FAQs: 'FAQs',
  TC: 'T&C',
  Login: 'Login',
  getCode: 'Send Otp',
  loginTips: 'Enter your phone number',
  otpTips: 'Please enter the OTP',
  phoneNumber: 'Phone Number',
  select_package: 'Please select package',
  daily_package: 'Daily Package',
  weekly_package: 'Weekly Package',
  monthly_package: 'Monthly Package',
  chances_2_day: '5 game chances / day',
  chances_14_day: '35 game chances / week',
  chances_60_day: '150 game chances / month',
  free_first_sub: 'Free for first registration',
  chances_2_day_Validity: 'Validity: 1 day',
  chances_14_day_Validity: 'Validity: 7 days',
  chances_60_day_Validity: 'Validity: 30 days',
  Register: 'Register',
  need_esim_prefix: 'Need a cellcard phone number? ',
  get_esim: 'Get eSIM',
  otp_confirm_title: 'Confirm Subscription',
  confirm: 'Confirm',
  cancel: 'Cancel',
  loadMore: 'Pull up to load more',
  loadMore2: 'No more data',
  Subscribe: 'Subscribe',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js